module.exports = __webpack_public_path__ + "static/media/SAM PHOEN.69e75808.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM PHOEN.webp
// module id = 90
// module chunks = 0